import React from 'react';
import PropTypes from 'prop-types';
import RangePickerHOC from 'components/widgets/dateRangePicker';
import momentPropTypes from 'react-moment-proptypes';
import NumberFormat from 'react-number-format';
import Lang from 'libraries/Lang';

const CustomRangePickerNights = (props) => {
    const {
        startDate,
        endDate,
        startDateId,
        endDateId,
        startDatePlaceholderText,
        endDatePlaceholderText,
        onFocus,
        showCalendar,
        customDateChanged,
        noOfNights,
        isDepDatevalid,
        isRetDatevalid,
        customNightChanged,
        activeTab,
        dateFormat,
        nightsDisable,
        validateDate,
    } = props;

    const app = document.getElementById('app');
    const { language } = app.dataset;

    // if(endDate && startDate && isDepDatevalid && isRetDatevalid) {
    // console.log(endDate.diff(startDate, 'days'))
    // }

    return (
        <div className="d-flex">
            {/* <button className="date-picker-btn position-relative col text-left col" type="button" id={startDateId} onClick={(e) => { onFocus('startDate'); showCalendar(e); }} >
                <span className="text-label">{ startDateId==="dyn_departureDate" ? "Departure" : "Check-in"}</span>
                {(startDate && startDate.format('MM/DD/YYYY')) || startDatePlaceholderText}
            </button> */}
            <div className="date-picker-btn position-relative col text-left col-md-4 col-4">

                <span className="text-label">{ startDateId === 'dyn_departureDate' ? Lang.trans('engine_travelgenie.departure') : 'Check-in'}</span>
                <label onClick={(e) => {
                    onFocus('startDate'); showCalendar(e);
                }}
                >   <svg className="icon right mt-3" title="">
                        <use xmlnsXlink="http://www.w3.org/2000/svg" xlinkHref="/img/icons/icon-defs.svg#icon-calendar" />
                    </svg>
                </label>
                <input
                    // mask="_"
                    // format="##/##/####"
                    className="w-100 h-100 py-0 pl-0 pb-1 pr-3"
                    placeholder={startDatePlaceholderText}
                    value={(startDate && isDepDatevalid && startDate.format(dateFormat)) || startDate}
                    id={startDateId}
                    name="depDate"
                    autoComplete="off"
                    onChange={(e) => { customDateChanged(e); }}
                    maxLength={language == 'en' ? "7" : "10"}
                    onBlur={(e) => { validateDate(e); }}
                />
            </div>
            <div className="date-picker-days-container date-picker-btn d-flex flex-column justify-content-center text-center px-2 left-border col col-md-4 col-4">
                <div className="text-label right"># {Lang.trans('engine_travelgenie.of_nights')}</div>
                {/* <div className="pb-1">{(startDate && endDate && endDate.diff(startDate, 'days')) || 0}</div> */}

                <input
                    type="text"
                    disabled={(!isDepDatevalid) && 'disabled'}
                    className="w-100 p-0 h-auto text-center"
                    value={startDate && endDate
                    && isDepDatevalid && isRetDatevalid
                    && (endDate.diff(startDate, 'days') > 0)
                        ? endDate.diff(startDate, 'days') : ''}
                    onChange={(e) => { customNightChanged(e); }}

                />

            </div>
            {/* <button className="date-picker-btn position-relative col text-left left-border" type="button" id={endDateId} onClick={(e) => { onFocus('endDate'); showCalendar(e); }}>
                <span className="text-label">{endDateId === "dyn_returnDate" ? "Return" : "Check-out"}</span>
                {(endDate && isRetDatevalid && endDate.format('MM/DD/YYYY')) || endDate}
            </button> */}
            <div className="date-picker-btn position-relative col text-left left-border col-md-4 col-4">

                <span className="text-label">{endDateId === 'dyn_returnDate' ? Lang.trans('engine_travelgenie.return') : 'Check-out'}</span>
                <label onClick={(e) => {
                    onFocus('endDate');
                    showCalendar(e);
                }}
                >   <svg className="icon right mt-3" title="">
                        <use xmlnsXlink="http://www.w3.org/2000/svg" xlinkHref="/img/icons/icon-defs.svg#icon-calendar" />
                    </svg>
                </label>
                <input
                    // mask="_"
                    // format="##/##/####"
                    className="w-100 h-100 py-0 pl-0 pb-1 pr-3"
                    placeholder={endDatePlaceholderText}
                    value={(endDate && isRetDatevalid && endDate.format(dateFormat)) || endDate}
                    id={endDateId === 'dyn_returnDate' ? 'Return' : 'Check-out'}
                    name="retDate"
                    onChange={(e) => { customDateChanged(e); }}
                    autoComplete="off"
                    maxLength={language == 'en' ? "7" : "10"}
                    onBlur={(e) => { validateDate(e); }}
                />
            </div>
        </div>
    );
};

CustomRangePickerNights.propTypes = {
    startDate: momentPropTypes.momentObj,
    endDate: momentPropTypes.momentObj,
    startDatePlaceholderText: PropTypes.string,
    endDatePlaceholderText: PropTypes.string,
    startDateId: PropTypes.string.isRequired,
    endDateId: PropTypes.string.isRequired,
    onFocus: PropTypes.func.isRequired,
    showCalendar: PropTypes.func.isRequired,
};

CustomRangePickerNights.defaultProps = {
    startDate: null,
    endDate: null,
    startDatePlaceholderText: 'Start Date',
    endDatePlaceholderText: 'End Date',
};

export default RangePickerHOC(CustomRangePickerNights);
